export default __webpack_public_path__ + "static/batisseStas-1c23c1556b7eb68ff6bd4f2ce703dbb9.webp";